import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';

import styles from './PopupInfo.module.scss';
import { overlayMotion, modalBoxMotionCentered } from '../motion/modalMotion';

import ButtonMain from "../buttons/ButtonMain/ButtonMain";

const PopupInfo = ({ text, setError }) => {
    const navigate = useNavigate();
    const reduce = useReducedMotion();

    return (
        <motion.div className={styles.overlay} {...overlayMotion(reduce)}>
            <motion.div className={styles.wrapper} {...modalBoxMotionCentered(reduce)}>
                <div className={styles.info}>
                    {text ? text : 'Something went wrong, please try again.'}
                </div>
                <ButtonMain
                    text={'ok'}
                    isNegative={true}
                    onClick={() => {
                        setError({hasError: false});
                        navigate('/');
                    }}
                />
            </motion.div>
        </motion.div>
    );
};

export default PopupInfo;